import { render, staticRenderFns } from "./FbReportsTable.vue?vue&type=template&id=08245b00&"
import script from "./FbReportsTable.vue?vue&type=script&lang=js&"
export * from "./FbReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports